import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import { flatMap, times } from 'lodash';

const { vfs } = vfsFonts.pdfMake;
pdfMake.vfs = vfs;

export const baseFontSize = 8;

const padding = (left, top, right, bottom) => ({
  paddingLeft: () => left,
  paddingTop: () => top,
  paddingRight: () => right,
  paddingBottom: () => bottom,
});

export const noPadding = padding(0, 0, 0, 0);

export const createTableHeader = cols =>
  cols.map(col => ({
    style: 'tableHeader',
    ...(typeof col === 'string' ? { text: col } : col),
  }));

export const createDividerRow = (colSpan, text) => [
  {
    colSpan: colSpan,
    //text: `${repeat('-', 30)} ${text} ${repeat('-', 30)}`,
    text: ' ',
    bold: true,
    fontSize: baseFontSize / 1.5,
    //color: 'grey',
    alignment: 'center',
  },
  ...times(colSpan - 1, {}),
];

export const createDocument = (title, content, { pageOrientation } = {}) => ({
  info: {
    title: [title, 'Nosturi'].join(' - '),
    creator: `Nosturi v${process.env.REACT_APP_VERSION}`,
  },
  pageSize: 'A4',
  pageOrientation,
  pageMargins: [40, 60, 40, 60],
  defaultStyle: {
    columnGap: 40,
    fontSize: baseFontSize,
  },
  styles: {
    header: {
      margin: [0, 0, 0, 16],
      fontSize: baseFontSize / 0.5,
      bold: true,
      alignment: 'center',
    },
    tableHeader: {
      bold: true,
    },
  },
  header: (page, pages) => ({
    margin: [40, 20, 40, 10],
    table: {
      widths: ['*', 'auto', '*'],
      body: [
        [
          { border: [true, true, false, true], text: '' },
          {
            border: [false, true, false, true],
            text: 'NOSTURI COMPETITION SYSTEM',
            bold: true,
            alignment: 'center',
          },
          { border: [false, true, true, true], text: '' },
        ],
      ],
    },
  }),
  content,
  footer: (page, pages) => ({
    margin: [40, 10, 40, 20],
    table: {
      widths: ['*', 'auto', '*'],
      body: [
        [
          {
            border: [true, true, false, true],
            text: title.toUpperCase(),
          },
          {
            border: [false, true, false, true],
            text: 'NOSTURI COMPETITION SYSTEM',
            bold: true,
            alignment: 'center',
          },
          {
            border: [false, true, true, true],
            text: `${page} / ${pages}`,
            alignment: 'right',
          },
        ],
      ],
    },
  }),
});

console.warn('FIXME: Do not hardcode event information!');
export const createPages = (records, createPage, meta) =>
  flatMap(records, (record, i) => [
    {
      text: `${meta.title}\n${meta.location} ${meta.duration}`,
      style: 'header',
      pageBreak: i ? 'before' : undefined,
    },
    ...createPage(record),
  ]);

export const createPdf = docDefinition => {
  const pdfGenerator = pdfMake.createPdf(docDefinition);

  return new Promise(resolve => pdfGenerator.getBuffer(resolve));
};

export default createPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/createPdf.js